import React from 'react';

type PaginationProps = {
  total: number;
  currentPage: number;
  pageSize: number;
  urlPrefix: string;
  letter: string;
  type?: string;
};

export default function Pagination({
  total,
  currentPage,
  pageSize,
  urlPrefix,
  letter
}: PaginationProps) {
  /* Pagination Logic
        url page(backend page number) 1 is page 2 in pagination, no query param is page 1 in pagination
        if total page count is greater than 1 only then pagination is shown
        first and previous will be shown in all pages except for the page 1
        last and next will be shown in all pages except for the last page number
        */
  const FIRST_PAGE = 1;
  // const urlPrefix = `city-city-index`;
  // NODE_ENV === 'production' ? `bus-tickets/city-index` : `city-index`;
  const getPaginationUrl = backendPageNumber =>
    `${urlPrefix}_${letter.toLowerCase()}_${backendPageNumber}.html`;

  const TOTAL_PAGES = Math.ceil(total / pageSize);
  const LAST_PAGE = TOTAL_PAGES;
  return TOTAL_PAGES > 1 ? (
    <div className="busSeoWrap__cityIndexSinglePagination">
      {currentPage !== FIRST_PAGE ? (
        <>
          <div className="busSeoWrap__cityIndexSinglePaginationPage">
            <a href={getPaginationUrl(FIRST_PAGE)}>« first</a>
          </div>
          <div className="busSeoWrap__cityIndexSinglePaginationPage">
            <a href={getPaginationUrl(currentPage - 1)}>‹ previous</a>
          </div>
        </>
      ) : (
        ''
      )}
      {Array.from({ length: TOTAL_PAGES }, (v, k) => k + 1)
        .filter(v => currentPage - 3 < v && v < currentPage + 3)
        .map(idx => {
          if (idx === currentPage) {
            return (
              <div
                className="busSeoWrap__cityIndexSinglePaginationPage"
                key={`page_${idx}`}
              >
                {idx}
              </div>
            );
          } else {
            return (
              <div
                className="busSeoWrap__cityIndexSinglePaginationPage"
                key={`page_${idx}`}
              >
                <a href={getPaginationUrl(idx)}>{idx}</a>
              </div>
            );
          }
        })}
      {currentPage !== LAST_PAGE ? (
        <>
          <div className="busSeoWrap__cityIndexSinglePaginationPage">
            <a href={getPaginationUrl(currentPage + 1)}>next ›</a>
          </div>
          <div className="busSeoWrap__cityIndexSinglePaginationPage">
            <a href={getPaginationUrl(LAST_PAGE)}>last »</a>
          </div>
        </>
      ) : (
        ''
      )}
    </div>
  ) : (
    <></>
  );
}
